export const SaveToLocalStorage = function (key, obj) {
return localStorage.setItem(key, JSON.stringify(obj))
}
export const SaveToSessionStorage = function (key, obj) {
return sessionStorage.setItem(key, JSON.stringify(obj))
}
export const GetFromLocalStorage = function (key) {
return JSON.parse(localStorage.getItem(key))
}
export const GetFromSessionStorage = function (key) {
return JSON.parse(sessionStorage.getItem(key))
}
export const RemoveFromLocalStorage = function (key) {
 return localStorage.removeItem(key)
}
export const RemoveFromSessionStorage = function (key) {
 return sessionStorage.removeItem(key)
}
export const randomUid = function() {
  return String(Math.floor(Math.random() * 9e15))
}
export const mcsToTime = function(microseconds) {
    // Calcolo di ore, minuti, secondi e microsecondi
    let milliseconds = Math.floor(microseconds / 1000);

    // Calcola ore, minuti, secondi e millisecondi
    let hours = Math.floor(milliseconds / (60 * 60 * 1000));
    milliseconds %= (60 * 60 * 1000);

    let minutes = Math.floor(milliseconds / (60 * 1000));
    milliseconds %= (60 * 1000);

    let seconds = Math.floor(milliseconds / 1000);
    milliseconds %= 1000;

    // Restituisci il formato leggibile
    return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
}